// extracted by mini-css-extract-plugin
export default {"delivery":"delivery--Of3co"};